import { FeatureBlock, FeatureComparison } from "../_copy-template"
import Enterprise from "~images/pages/features/enterprise.png"

export function getEnterpriseCopy(competitor: FeatureBlock): FeatureComparison {
    return {
        name: "Enterprise",
        image: Enterprise,
        chckup: {
            showCheck: true,
            description:
                "With Chckvet, you can easily track & manage the performances of all your locations in one easy-to-digest place. Because Chckvet's solution cohesively works with every aspect of your business, you can pull financial, operational, marketing, & other important data all into one place. We also standardize data across different PIMS.",
        },
        competitor,
        href: "/features/enterprise",
    }
}
